import { Editor, Transforms, Element } from 'slate';
import NormalizeTopLevelElement from './normalizeTopLevelElement';
import { isTopLevel } from '..';
const OnRemoveTopLevelElement = (listeners) => {
    const normalizeTopLevelElement = NormalizeTopLevelElement(listeners);
    return (op, editor) => {
        const index = op.path[0];
        if (listeners.onBlockDelete) {
            if (Element.isElement(op.node) && isTopLevel(op.node)) {
                if (op.node.mdastNode) {
                    listeners.onBlockDelete(op.node.mdastNode, op.node);
                }
            }
        }
        if (index <= 0) {
            // No prev sibling
            return;
        }
        if (index >= editor.children.length) {
            // No next sibling
            return;
        }
        const prevSibElement = editor.children[index - 1];
        const nextSibElement = editor.children[index];
        if (prevSibElement == null || nextSibElement == null) {
            return;
        }
        // Editor.mergeNodes(editor, { at: [index] });
        Editor.withoutNormalizing(editor, () => {
            Transforms.moveNodes(editor, {
                at: [index],
                match: (node) => node.type === 'line',
                to: [index - 1, prevSibElement.children.length],
            });
            Transforms.removeNodes(editor, { at: [index] });
            const newElement = editor.children[index - 1];
            if (newElement == null) {
                throw new Error('Merged element not found');
            }
            normalizeTopLevelElement(newElement, index - 1, editor);
        });
    };
};
export const withMarkdownOnChange = (editor, listeners) => {
    const onRemoveTopLevelElement = OnRemoveTopLevelElement(listeners);
    const { onChange } = editor;
    editor.onChange = () => {
        const removeNodeOps = editor.operations.filter((op) => op.type === 'remove_node');
        removeNodeOps.forEach((removeNodeOp) => {
            if (removeNodeOp.path.length === 1) {
                onRemoveTopLevelElement(removeNodeOp, editor);
            }
        });
        onChange();
    };
    return editor;
};
//# sourceMappingURL=onChange.js.map